import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import React, { useEffect } from "react";
import LayoutCabecalhoRodape from "./pages/layoutRodapeCabecalho/layoutRodapeCabecalho";
import Cabecalho from "./components/layout/cabecalho/cabecalho";
import Spinner from './components/spinner/spinner';
import EmConstrucao from "./pages/paginasDoSistema/emConstrucao";
import NaoAutorizado from "./pages/paginasDoSistema/naoAutorizado";
import HomePage from "./pages/HomePage";
import Login from "./pages/login/login";
import EsqueceuSenha from "./pages/usuarios/esqueceuSenha";
import RedefinirSenha from "./pages/usuarios/redefinirSenha";
import IncluirCidade from "./pages/cidades/incluirCidade";
import ConsultaCidade from "./pages/cidades/consultaCidade";
import VisualizarCidade from "./pages/cidades/visualizarCidade";
import AlterarCidade from "./pages/cidades/alterarCidade";
import ExcluirCidade from "./pages/cidades/excluirCidade";
import IncluirAnuncio from "./pages/anuncios/incluirAnuncio/incluirAnuncio";
import VisualizarAnuncio from "./pages/anuncios/visualizarAnuncio/visualizarAnuncio";
import AlterarAnuncio from "./pages/anuncios/alterarAnuncio/alterarAnuncio";
import ExcluirAnuncio from "./pages/anuncios/excluirAnuncio/excluirAnuncio";
import IncluirUsuario from "./pages/usuarios/incluirUsuario";
import VisualizarUsuario from "./pages/usuarios/visualizarUsuario";
import ConsultaUsuario from "./pages/usuarios/consultaUsuario";
import AlteraUsuario from "./pages/usuarios/alterarUsuario";
import MeusAnuncios from "./pages/usuarios/meusAnuncios";
import MeusFavoritos from "./pages/usuarios/meusFavoritos";

const RotaUser = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/milshop/login" replace={true} />;
  }
  return children;
};

const RotaAdmin = ({ children }: { children: React.ReactElement }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) {
    const erroMessage = "Você não tem autorização para acessar aquela página.";
    return <Navigate to={`/milshop/naoAutorizado`} />
  }
  return children;
};

const Autorizado = ({ children }: { children: React.ReactElement }) => {
  const { estaAutorizado } = useAuth();
  if (!estaAutorizado) {
    const erroMessage = "Você não tem autorização para acessar aquela página.";
    return <Navigate to={`/milshop/naoAutorizado`} />
  }
  return children;
};

export default function AppRoutes(): React.ReactElement {

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/milshop" element={<LayoutCabecalhoRodape><HomePage /></LayoutCabecalhoRodape>} />
          <Route path="/milshop/login" element={<Login />} />
          <Route path="/milshop/esqueci-senha" element={<><Cabecalho /><EsqueceuSenha /></>} />
          <Route path="/milshop/redefinir-senha" element={<><Cabecalho /><RedefinirSenha /></>} />

          <Route path="/milshop/usuario/incluir" element={<LayoutCabecalhoRodape><IncluirUsuario /></LayoutCabecalhoRodape>} />
          <Route path="/milshop/emConstrucao" element={<LayoutCabecalhoRodape><EmConstrucao /></LayoutCabecalhoRodape>} />
          <Route path="/milshop/naoAutorizado" element={<LayoutCabecalhoRodape><NaoAutorizado /></LayoutCabecalhoRodape>} />

          {/* Rotas protegidas */}
          <Route path="/milshop/cidade/incluir" element={<RotaUser>
            <RotaAdmin>
              <Autorizado>
                <LayoutCabecalhoRodape>
                  <IncluirCidade />
                </LayoutCabecalhoRodape>
              </Autorizado>
            </RotaAdmin></RotaUser>} />
          <Route path="/milshop/cidade/consultar" element={<RotaUser>
            <RotaAdmin>
              <Autorizado>
                <LayoutCabecalhoRodape>
                  <ConsultaCidade />
                </LayoutCabecalhoRodape>
              </Autorizado>
            </RotaAdmin>
          </RotaUser>} />

          <Route path="/milshop/cidade/ver-detalhes/:cdCidade" element={<RotaUser>
            <RotaAdmin>
              <Autorizado>
                <LayoutCabecalhoRodape>
                  <VisualizarCidade />
                </LayoutCabecalhoRodape>
              </Autorizado>
            </RotaAdmin>
          </RotaUser>} />

          <Route path="/milshop/cidade/alterar/:cdCidade" element={<RotaUser>
            <RotaAdmin>
              <Autorizado>
                <LayoutCabecalhoRodape>
                  <AlterarCidade />
                </LayoutCabecalhoRodape>
              </Autorizado>
            </RotaAdmin>
          </RotaUser>} />

          <Route path="/milshop/cidade/excluir/:id" element={<RotaUser>
            <RotaAdmin>
              <Autorizado>
                <LayoutCabecalhoRodape>
                  <ExcluirCidade />
                </LayoutCabecalhoRodape>
              </Autorizado>
            </RotaAdmin>
          </RotaUser>} />

          <Route path="/milshop/anuncio/incluir" element={<RotaUser><Autorizado><LayoutCabecalhoRodape><IncluirAnuncio /></LayoutCabecalhoRodape></Autorizado></RotaUser>} />
          <Route path="/milshop/anuncio/ver-detalhes/:id" element={<Autorizado><LayoutCabecalhoRodape><VisualizarAnuncio /></LayoutCabecalhoRodape></Autorizado>} />
          <Route path="/milshop/anuncio/alterar/:cdAnuncio" element={<RotaUser><Autorizado><LayoutCabecalhoRodape><AlterarAnuncio /></LayoutCabecalhoRodape></Autorizado></RotaUser>} />
          <Route path="/milshop/anuncio/excluir/:cdAnuncio" element={<RotaUser><Autorizado><LayoutCabecalhoRodape><ExcluirAnuncio /></LayoutCabecalhoRodape></Autorizado></RotaUser>} />


          <Route path="/milshop/usuario/consultar" element={<RotaUser>
            <RotaAdmin>
              <LayoutCabecalhoRodape>
                <ConsultaUsuario />
              </LayoutCabecalhoRodape>
            </RotaAdmin>
          </RotaUser>} />
          <Route path="/milshop/usuario/ver-detalhes/:cdUsuario" element={<RotaUser><LayoutCabecalhoRodape><VisualizarUsuario /></LayoutCabecalhoRodape></RotaUser>} />
          <Route path="/milshop/usuario/alterar/:cdUsuario" element={<RotaUser><LayoutCabecalhoRodape><AlteraUsuario /></LayoutCabecalhoRodape></RotaUser>} />
          <Route path="/milshop/usuario/meus-anuncios" element={<LayoutCabecalhoRodape><MeusAnuncios /></LayoutCabecalhoRodape>} />
          <Route path="/milshop/usuario/meus-favoritos" element={<RotaUser><LayoutCabecalhoRodape><MeusFavoritos /></LayoutCabecalhoRodape></RotaUser>} />

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
